import React, { useState } from "react"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"

interface Item {
    value: number,
    text: string
}
interface ComponentProps {
    data: Item[],
    initValue?: number | string,
    onChange: (value: number | string) => void,
}
const menuProps = {
    style: {
        maxHeight: 48 * 10.5,
        width: 200,
    },
}
// 选择框
export default (props: ComponentProps) => {
    const { data, initValue = "", onChange } = props
    const [ value, setValue ] = useState(initValue)
    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setValue(event.target.value as string | number)
        onChange(event.target.value as string | number)
    }
    return (
        <Select value={value} MenuProps={menuProps} onChange={handleChange}>
            <MenuItem value="">
                <em>请选择</em>
            </MenuItem>
            {
                data.map(({ value, text }: Item) => (
                    <MenuItem key={value} value={value}>{text}</MenuItem>
                ))
            }
        </Select>
    )
}

